import { useEffect, useRef, useState } from 'react';
import { NAV } from '../data/site.js';
import { useActiveSection, scrollToId } from '../hooks/useActiveSection.js';
import clinicLogo from '../assets/images/clinicLogo.png';

const SECTION_IDS = NAV.map((n) => n.id);

export default function Navbar({ scrolled }) {
  const [open, setOpen] = useState(false);
  const active = useActiveSection(SECTION_IDS);
  const navRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    const onClick = (e) => {
      if (open && navRef.current && !navRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('click', onClick);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onClick);
    };
  }, [open]);

  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };

  return (
    <nav id="navbar" ref={navRef} className={scrolled ? 'scrolled' : ''}>
      <div className="nav-inner">
        <a href="#home" className="logo" onClick={(e) => go(e, 'home')}>
          <img className="logo-img" src={clinicLogo} alt="Kanaga Dental Clinic" />
        </a>

        <ul className={`nav-links ${open ? 'open' : ''}`} id="navLinks">
          {NAV.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className={`nav-link ${item.cta ? 'nav-cta' : ''} ${
                  active === item.id ? 'active' : ''
                }`.trim()}
                aria-current={active === item.id ? 'true' : undefined}
                onClick={(e) => go(e, item.id)}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className={`burger ${open ? 'open' : ''}`}
          aria-label="Toggle menu"
          aria-expanded={open}
          aria-controls="navLinks"
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </nav>
  );
}
